import { Component, inject, signal } from '@angular/core';
import { DistrictNav } from '../district-nav/district-nav';
import { MatAnchor } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { SisDialog } from './sis-dialog/sis-dialog';
import { DistrictAdminService } from '../../../../services/district-admin.service';
import { Integration, ISyncHistoryEntry } from '../../../../models/integration';

@Component({
  selector: 'app-sis-integration',
  imports: [DistrictNav, MatAnchor, NgClass, MatIcon],
  templateUrl: './sis-integration.html',
  styleUrl: './sis-integration.css',
})
export class SISIntegration {
  private dialog: MatDialog = inject(MatDialog);
  private districtService = inject(DistrictAdminService);

  connectionState = 'pending';
  connectionStatusLabel = 'pending';
  secretRevealed = false;
  maskedSecret = '••••••••••••••••';
  syncHistory: ISyncHistoryEntry[] = [];
  integration = signal<Integration>(new Integration());
  lastSuccessful: ISyncHistoryEntry | undefined;

  ngOnInit() {
    this.districtService.getIntegration().subscribe({
      next: (integration) => {
        this.integration.set(integration);
        this.connectionStatusLabel = this.integration().status;
        this.connectionState = this.integration().status.toLowerCase();
        this.syncHistory = this.integration().syncHistory;
        this.getLastSuccessfulSync();
      },
      error: (err) => {},
    });
  }

  getLastSuccessfulSync(): void {
    this.lastSuccessful = [...this.syncHistory].reverse().find((entry) => entry.success);
  }

  openIntegrationDialog() {
    const dialogRef = this.dialog.open(SisDialog, {
      width: '780px',
      maxWidth: '95vw',
      data: { integration: null },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data) {
        this.integration.set(Integration.digest(result.data));
        console.log(this.integration);
        this.connectionState = this.integration().status.toLowerCase();
        this.connectionStatusLabel = this.integration().status;
        this.syncHistory = this.integration().syncHistory;
        this.getLastSuccessfulSync();
      }
    });
  }

  editConnection() {
    const dialogRef = this.dialog.open(SisDialog, {
      width: '780px',
      maxWidth: '95vw',
      data: { integration: this.integration() },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data) {
        this.integration.set(Integration.digest(result.data));
        this.connectionState = this.integration().status.toLowerCase();
        this.connectionStatusLabel = this.integration().status;
        this.syncHistory = this.integration().syncHistory;
        this.getLastSuccessfulSync();
      }
    });
  }

  manualSync() {
    this.districtService.syncIntegration().subscribe({
      next: (integration) => {
        this.integration.set(integration);
        this.connectionStatusLabel = this.integration().status;
        this.connectionState = this.integration().status.toLowerCase();
        this.syncHistory = this.integration().syncHistory;
        this.getLastSuccessfulSync();
      },
      error: (err) => {
        console.error('sync integration failed:', err);
      },
    });
  }
}
